import React, { PureComponent } from 'react';
import cn from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Label, FormGroup, InputGroup, InputGroupAddon, Input, Button, Fade } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';
import { parse } from 'query-string';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

class FlowLink extends PureComponent {
  static propTypes = {
    link: string.isRequired,
    id: string.isRequired,
    defaultMessage: string.isRequired,
  };

  static defaultProps = {
    link: '',
    id: 'flow.form.link.title',
    defaultMessage: 'Your link',
  };

  state = {
    copied: false,
  };

  componentDidMount() {
    this._mounted = true;
    // const { theme, history } = this.props;
    // if (theme === 4) {
    //   const params = parse(history.location.search);
    //   params.created &&
    //     window.scrollTo({ top: document.body.scrollHeight, left: 0, behavior: 'smooth' });
    // }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleCopy = () => {
    this.setState(
      () => ({ copied: true }),
      () => {
        setTimeout(() => {
          this._mounted && this.setState(() => ({ copied: false }));
        }, 1200);
      },
    );
  };

  render() {
    const { copied } = this.state;
    const { link, id, defaultMessage } = this.props;

    return (
      <FormGroup className={cn('form-group-upper-label', 'flow-form-link-container')}>
        <Label>
          <FormattedMessage id={id} defaultMessage={defaultMessage} />{' '}
        </Label>
        <InputGroup>
          <Input className="stream-link" value={link} readOnly />
          <InputGroupAddon addonType="append">
            <CopyToClipboard text={link} onCopy={this.handleCopy}>
              <Button type="button" color="primary" onClick={this.handleClick}>
                {copied ? (
                  <Fade in={copied} tag="span" className="copy-message">
                    <SVG
                      src={`${STATIC_PATH}/img/action-icons/check.svg`}
                      height="20"
                      width="20"
                      cacheRequests
                    />
                  </Fade>
                ) : (
                  <SVG
                    src={`${STATIC_PATH}/img/action-icons/copy_flow.svg`}
                    height="20"
                    width="20"
                    cacheRequests
                  />
                )}
              </Button>
            </CopyToClipboard>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    );
  }
}

export default FlowLink;
